import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';

const StyledEducationSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 50px 40px;
  text-align: left;

  h2 {
    font-size: var(--fz-heading);
    margin-bottom: 40px;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      margin-bottom: 20px;
      font-size: var(--fz-lg);
      display: flex;
      flex-direction: column;

      .education-header {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 5px;

        .education-title {
          font-weight: bold;
          color: var(--green);
          font-size: var(--fz-xl);
        }

        .institute {
          color: var(--light-slate);
          font-size: var(--fz-md);
          margin-top: 3px;
        }
      }

      .location {
        font-size: var(--fz-sm);
        color: var(--slate);
        margin-bottom: 3px;
      }

      .range {
        font-size: var(--fz-sm);
        color: var(--slate);
        margin-bottom: 5px;
      }

      .description {
        font-size: var(--fz-md);
        color: var(--light-slate);
        line-height: 1.5; /* Increased line-height for better readability */
        margin-bottom: 10px;

        ul {
          margin: 10px 0 0 0; /* Add margin top to separate from paragraph */
          padding-left: 20px;
          list-style: disc; /* Use standard disc bullets */

          li {
            margin-bottom: 8px; /* Add spacing between list items */
            line-height: 1.4; /* Adjust line-height for list items */
            padding-left: 5px; /* Add padding for alignment */
          }
        }
      }
    }
  }
`;

const Education = () => {
  const data = useStaticQuery(graphql`
    query {
      education: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/content/education/" } }
        sort: { fields: [frontmatter___date], order: DESC }
      ) {
        edges {
          node {
            frontmatter {
              title
              institute
              location
              range
              description
            }
          }
        }
      }
    }
  `);

  const educationData = data.education.edges;

  return (
    <StyledEducationSection id="education">
      <h2 className="numbered-heading">Education</h2>
      <ul>
        {educationData.map(({ node }, i) => {
          const { title, institute, location, range, description } = node.frontmatter;
          return (
            <li key={i}>
              <div className="education-header">
                <span className="education-title">{title}</span>
                <span className="institute">{institute}</span>
              </div>
              <div className="location">{location}</div>
              <div className="range">{range}</div>
              {description && (
                <div className="description">
                  <p>{description.split('\n')[0]}</p>
                  <ul>
                    {description
                      .split('\n')
                      .slice(1)
                      .map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                  </ul>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </StyledEducationSection>
  );
};

export default Education;
